import { Directive, ElementRef, Input, OnDestroy, OnInit } from '@angular/core';
import { Subject, Subscription } from 'rxjs';
import { debounceTime, tap } from 'rxjs/operators';

import {
    TakeUntilDestroy,
    takeUntilDestroy,
} from '../../../common/take-until-destroy.decorator';
import { filterRows } from '../function/filter-rows.function';
import { currentMainState } from '../game-plan.state';

@Directive({
    selector: 'input[cmpsSearchInput]',
    host: {
        '[value]': "keyword ?? ''",
        '(input)': '_onKeywordFilterChange($event)',
        '(keydown.enter)':
            '$event.preventDefault(); _dispatchFilterKeyword(searchInputRef.value)',
    },
})
@TakeUntilDestroy()
export class SearchInputDirective implements OnInit, OnDestroy {
    @Input() keyword: string;

    private _keywordSubj: Subject<string>;
    private _keywordSub: Subscription;

    constructor(private readonly _el: ElementRef<HTMLInputElement>) {}

    ngOnInit(): void {
        this._initKeyword();
        this._el.nativeElement?.focus();
    }

    ngOnDestroy(): void {
        this._keywordSub?.unsubscribe();
        this._keywordSubj?.complete();
    }

    /** @private */
    _onKeywordFilterChange(): void {
        this._keywordSubj.next(this._el.nativeElement?.value);
    }

    /** @private */
    _dispatchFilterKeyword(keyword: string): void {
        currentMainState().keyword = (keyword ?? '').toLowerCase().trim();
        filterRows();
    }

    private _initKeyword(): void {
        this._keywordSubj = new Subject();
        this._keywordSub = this._keywordSubj
            .asObservable()
            .pipe(
                debounceTime(500),
                tap((keyword) => {
                    this._dispatchFilterKeyword(keyword);
                }),
                takeUntilDestroy(this),
            )
            .subscribe();
    }
}
